import React from 'react';
import { IPublicMaterialPricing, IPublicPricing } from '../../services/pricing_public/pricing_public';
import { Slider } from './Controls.component';
import { money, WallEstimate } from './earnings';
import { ResultPanel, ResultRow } from './ResultPanel.component';

interface Props {
    pricing: IPublicPricing;
    material: IPublicMaterialPricing;
    royalty: number;
    onRoyalty: (value: number) => void;
    estimate: WallEstimate;
    ordersPerMonth: number;
    /** The wall, material and orders controls shared with the store view. */
    sharedControls: React.ReactNode;
    columns: string;
}

// #region EarningsCalculator
/** "Licensing": a royalty in, what one licensed order pays the artist out. */
export const EarningsCalculator: React.FunctionComponent<Props> = ({ pricing, material, royalty, onRoyalty, estimate, ordersPerMonth, sharedControls, columns }): React.ReactElement => {
    const fee = pricing.licensing_fee;
    const feeLabel = fee.type === 'PERCENTAGE' ? `${fee.value}%` : money(fee.value);
    return (
        <div className={`grid gap-6 ${columns} sm:gap-8`}>
            <div className="flex flex-col gap-6">
                <Slider
                    id="pricing-royalty"
                    label="Your royalty"
                    display={`${royalty}%`}
                    value={royalty}
                    min={1}
                    max={30}
                    onChange={onRoyalty}
                    hint="You set it per design. Brands see it before they license."
                />
                {sharedControls}
            </div>

            <ResultPanel label="Your monthly payout" perOrder={estimate.net} ordersPerMonth={ordersPerMonth}>
                <ResultRow term={`Wall value · ${estimate.panels} panels × ${estimate.panelHeightFt} ft, ${material.label}`} value={money(estimate.basis)} muted />
                <ResultRow term={`Your ${royalty}% royalty`} value={money(estimate.gross)} />
                <ResultRow term={`Wallmates fee (${feeLabel})`} value={`−${money(estimate.fee)}`} muted />
                <ResultRow term="You keep" value={money(estimate.net)} strong />
            </ResultPanel>
        </div>
    );
};
